import React from "react"
import "./PublicPage.scss"
import { ClassProps } from "../../utility/common/props"
import cn from "classnames"
import Logo from "../Logo/Logo"
import LanguageSelector from "../LanguageSelector/LanguageSelector"
import { useDispatch } from "react-redux"
import { push } from "connected-react-router"

export interface MessageProps extends ClassProps {
    title?: string
    text: string
}

type IPublicPage<P> = React.FC<P> & {
    Message: typeof Message
}

const Message: React.FC<MessageProps> = props => {
    const { title, text, children, className } = props
    return (
        <div className={cn("public-page-message", className)}>
            {title && <h1 className="public-page-message__title">{title}</h1>}
            <p className="public-page-message__text">{text}</p>
            <div className="public-page-message__image">{children}</div>
        </div>
    )
}

export interface PublicPageProps extends ClassProps {
    title?: string
    hideLogo?: boolean
    hideLanguageSelector?: boolean
    hidePrivacyPolicy?: boolean
    hideTermOfUse?: boolean
    contentInCenter?: boolean
    onClick?: () => void
}

const PublicPage: IPublicPage<PublicPageProps> = props => {
    const { title, className, hideLogo, hideLanguageSelector, children, contentInCenter, onClick } = props
    const dispatch = useDispatch()
    const goToRoot = () => dispatch(push("/"))

    return (
        <div className={cn("public-page", className, contentInCenter && "public-page_centered")}>
            <div className="public-page__header header">
                <div className="header__left">{!hideLogo && <Logo onClick={onClick ?? goToRoot} />}</div>
                {title && <h2 className="public-page__title">{title}</h2>}
                <div className="header__right">{!hideLanguageSelector && <LanguageSelector />}</div>
            </div>
            <div className="public-page__body">{children}</div>
            <div className="public-page__footer footer">
                <div className="footer__left" />
                <div className="footer__right" />
            </div>
        </div>
    )
}

PublicPage.Message = Message

export default PublicPage
